/**
 * API endpoints
 */
export const API_ENDPOINTS = {
  CREATE_INVITE: '/create-invite',
  GET_INVITE: (id: string) => `/invite/${id}`,
  CREATE_RSVP: (id: string) => `/rsvp/${id}`,
  GET_USER_INVITES: (telegramUserId: string) => `/telegram/invites/${telegramUserId}`,
  ADMIN_INVITES: '/admin/invites',
  ADMIN_UPDATE_INVITE: (id: string) => `/admin/invites/${id}`,
  ADMIN_DELETE_INVITE: (id: string) => `/admin/invites/${id}`,
  ADMIN_TELEGRAM_BROADCAST: '/admin/telegram/broadcast',
  TELEGRAM_TEST: '/telegram/test',
} as const;

/**
 * Базовый URL API
 */
export const getApiBaseUrl = (): string => import.meta.env.VITE_API_URL || 'http://localhost:8787';

/**
 * Таймаут для API запросов (в миллисекундах)
 */
export const API_TIMEOUT = 30000;

/**
 * Заголовки по умолчанию для API запросов
 */
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
} as const;
